export default "__VITE_ASSET__ByrMruNt__"